<template>
  <div
      :is="driver + '-form'"
      v-model="data"
      :errors="errors"
  />
</template>

<script>
import AdvertisingSalesForm from '@/components/Administration/Competitions/DriverParameterForms/AdvertisingSales'
import AdvertisingStarsForm from '@/components/Administration/Competitions/DriverParameterForms/AdvertisingStars'
import PartnershipSalesForm from '@/components/Administration/Competitions/DriverParameterForms/PartnershipSales'
import PartnershipStarsForm from '@/components/Administration/Competitions/DriverParameterForms/PartnershipStars'
import SalesForm from '@/components/Administration/Competitions/DriverParameterForms/Sales'
import StarsForm from '@/components/Administration/Competitions/DriverParameterForms/Stars'

export default {
  components: {AdvertisingSalesForm, AdvertisingStarsForm,PartnershipSalesForm,PartnershipStarsForm, SalesForm, StarsForm},

  props: {
    driver: {
      required: true
    },

    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
